import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
const perks = ["Immediate Digital Access", "6 Actionable Volumes", "5 Practical Clinical Tools", "Reusable Assessment & Planning Templates", "7-Day Money-Back Guarantee"];
export function Hero() {
  return <header className="bg-plum-900 px-4 pb-12 pt-6 text-white sm:pt-10" data-id="element-204" data-mp="mu0n2jtgnfrg">
      <div className="mx-auto max-w-5xl" data-id="element-205" data-mp="mtsakt192cgs">
        <p className="mx-auto w-fit rounded-full bg-mint-500 px-4 py-1.5 text-center text-xs font-extrabold uppercase text-plum-950 sm:text-sm" data-id="element-206" data-mp="qvdrcpgwnaw9">
          For Pediatric OTs, SLPs & Feeding Specialists
        </p>

        <h1 className="mt-5 text-center font-display text-[34px] font-extrabold leading-[1.08] sm:text-5xl lg:text-6xl" data-id="element-207" data-mp="10lozko7mg68y">
          PEDIATRIC FEEDING <span className="text-mint-400" data-id="element-208" data-mp="15mcxltu9pnco">THERAPY BLUEPRINT™</span>
        </h1>

        <p className="mx-auto mt-4 max-w-3xl text-center text-lg font-semibold leading-snug text-plum-100 sm:text-2xl" data-id="element-209" data-mp="1akeimkb97wqs">
          Turn a Complex Pediatric Feeding Case Into a{" "}
          <span className="text-sun" data-id="element-210" data-mp="4ogb57pcn2c5">Structured Assessment, Documented Clinical Priorities,</span> and an{" "}
          <span className="text-sun" data-id="element-211" data-mp="3vw2et0c2j4t0">Individualized Therapy Planning Draft</span> in One Organized Workflow.
        </p>

        <div className="mt-6 lg:grid lg:grid-cols-2 lg:items-center lg:gap-10" data-id="element-212" data-mp="3rv8o5z78rbwf">
          <img src={images.mockup} alt="Pediatric Feeding Therapy Blueprint — 6 volumes and 5 bonuses" className="-mx-4 w-[calc(100%+2rem)] max-w-none rounded-none bg-white sm:mx-auto sm:w-full sm:rounded-3xl lg:max-w-full" data-id="element-213" data-mp="sczauyuc26sm" />

          <div className="mt-6 lg:mt-0" data-id="element-214" data-mp="enfdy9nfo3r8">
            <p className="text-center text-base leading-relaxed text-plum-100 sm:text-lg lg:text-left" data-id="element-215" data-mp="emdylszdwv3p">
              Stop piecing together scattered observations, incomplete notes, and disconnected therapy goals. Use the{" "}
              <strong className="text-white" data-id="element-216" data-mp="16c8te560hczr">PEDIATRIC FEEDING DECISION PATHWAY™</strong> to organize feeding-related
              information, identify clinical priorities, document relevant observations, and build a structured therapy
              planning draft using practical decision tools.
            </p>

            <p className="mt-5 text-center font-display text-xl font-extrabold text-mint-300 lg:text-left" data-id="element-217" data-mp="2vuxi995my0wb">
              6 Practical Volumes + 5 Professional Bonuses
            </p>

            <div className="mt-4 rounded-2xl bg-white p-4 text-center text-plum-950" data-id="element-218" data-mp="2hxsddchnr82n">
              <p className="text-xs font-extrabold uppercase text-plum-700" data-id="element-219" data-mp="2msfw0upzd89b">Today’s digital offer</p>
              <p className="font-display text-5xl font-extrabold text-cta" data-id="element-220" data-mp="27zcl366w9srk">
                JUST $27 <span className="text-lg text-slate-500" data-id="element-221" data-mp="2cwl75hv5ygy3">USD</span>
              </p>
              <p className="text-xs font-semibold text-slate-600" data-id="element-222" data-mp="66epx3pnao3g">One-time payment · Currency converted automatically</p>
            </div>

            <div className="mt-5" data-id="element-223" data-mp="1vn0i54tm2kmb">
              <CtaButton id="first-cta" label="Get My Pediatric Feeding Blueprint for $27" data-id="element-224" data-mp="1vm90kxwumnf1" />
            </div>

            <ul className="mx-auto mt-5 grid max-w-xl gap-2 sm:grid-cols-2" data-id="element-225" data-mp="1qoz3cw37x7gn">
              {perks.map(p => <li key={p} className="flex items-start gap-2 text-sm font-semibold text-white" data-id="element-226" data-mp="25eempr0f6amb">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-400" aria-hidden="true" data-id="element-227" data-mp="20kiuz6ar1jzl" />
                  {p}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-2 text-xs leading-relaxed text-plum-200" data-id="element-228" data-mp="2abdew40iw7hv">
          <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-229" data-mp="2oawmmvpf9gtn" />
          Professional educational resources designed to support clinical organization and documentation—not replace
          individualized assessment, clinical judgment, or appropriate medical referral.
        </p>
      </div>
    </header>;
}